import React, { useEffect, useState } from "react";
import Request from "../../../../helpers/request";
import * as url from "../../../../helpers/url_helper";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import ConfirmationModal from "../../../../components/Common/ConfirmationModal";
import ChipsDataTable from "./ChipsDetail/ChipsDataTable";
import { AssignIcon, DeleteIcon, MqttIcon } from "../../../../assets/svg";
import DataTable from "react-data-table-component";
import { ActionButton } from "../../../../components/Common/button";
import AssignRoomModal from "./AssignRoomModal";

export interface ChipsControlProps {
  userId: any;
  selectedPremise?: any;
}

const BlasterList = ({ userId }: ChipsControlProps) => {
  const selectedRooms = useSelector(
    (state: any) => state.APIResponse.selectedRooms
  );
  const [loading, setLoading] = useState<boolean>(false);
  const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);
  const [deleteData, setDeleteData] = useState<any>();
  const [assignData, setAssignData] = useState<any>({});
  const [isAssignRoomModalOpen, setIsAssignRoomModalOpen] = useState(false);
  const [isReload, setReload] = useState<boolean>(false);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);

  const columns = [
    {
      name: "Slave",
      selector: (row: any) => row.slave || "-",
      sortable: true,
      grow: 1.5,
      wrap: true,
    },
    {
      name: "Device IP",
      selector: (row: any) => (row.deviceIp ? row.deviceIp : "-"),
      sortable: true,
      grow: 1.5,
      wrap: true,
    },

    {
      name: "HW-V",
      selector: (row: any) => row.hwVersion || "-",
      sortable: true,
      grow: 0.5,
      wrap: true,
    },
    {
      name: "WI-V",
      selector: (row: any) => row.wifiVersion || "-",
      sortable: true,
      grow: 0.5,
      wrap: true,
    },

    {
      name: "Name",
      selector: (row: any) => row.name || "-",
      sortable: true,
      grow: 1.5,
      wrap: true,
    },
    {
      name: "Status",
      selector: (row: any) => (row.isOnline ? "Online" : "Offline"),
      cell: (row: any) =>
        row.isOnline === true ? (
          <span className="font-size-11 badge-soft-success badge bg-secondary">
            online
          </span>
        ) : (
          <span className="font-size-11 badge-soft-danger badge bg-secondary">
            Offline
          </span>
        ),
      sortable: true,
      grow: 0.5,
      wrap: true,
    },

    {
      name: "Actions",
      grow: 2,
      cell: (row: any) => (
        <div className="d-flex align-items-center" style={{ gap: "12px" }}>
          <ActionButton
            id="DeleteIconButton"
            title="Delete"
            icon={<DeleteIcon />}
            onClick={() => handleDeleteClick(row)}
          />
          <ActionButton
            id="MQTTLogsIconButton"
            title="MQTT Logs"
            icon={<MqttIcon />}
            onClick={() => handleMQTTData(row)}
          />
          <ActionButton
            id="AssignIconButton"
            title="Assign Room"
            icon={<AssignIcon />}
            onClick={() => handleAssignClick(row)}
          />
        </div>
      ),
    },
  ];
  const handleRefresh = () => {
    setReload((prev) => !prev);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      handleRefresh();
    }, 30000);

    return () => clearInterval(interval);
  }, []);
  const deleteBlasterApiCall = () => {
    setLoading(true);
    const reqObj = {
      blasterId: deleteData.id,
    };

    Request.post(url.DELETE_USER_BLASTER, reqObj)
      .then((res) => {
        // areaListApiCall()
        toast.success(res.data.msg);
        setDeleteModalOpen(false);
        setLoading(false);
        handleRefresh();
      })
      .catch((err) => {
        setLoading(false);
        // showToast("error", err.response.data.errors[0]?.msg)
      });
  };

  const handleDeleteClick = (rowData: any) => {
    setDeleteModalOpen(!isDeleteModalOpen);
    setDeleteData(rowData);
    // Add your logic here
  };
  const handleAssignClick = (row: any) => {
    if (row !== undefined) {
      setIsAssignRoomModalOpen(!isAssignRoomModalOpen);
      setAssignData(row);
    }
  };
  const handleMQTTData = (rowData: any) => {
    rowData?.slave
      ? window.open(`/debug-device-details/${rowData?.slave}`, "_blank")
      : "";
  };
  const handleDeleteAll = () => {
    if (selectedRows.length > 0) {
      toast.info("This feature will be available soon.");
    }
  };

  return (
    <div>
      {isDeleteModalOpen && (
        <ConfirmationModal
          headerTitle="Delete Blaster?"
          text="Are you sure you want to delete this Blaster ? This action cannot be undone."
          buttonText="Delete"
          onClick={() => {
            deleteBlasterApiCall();
          }}
          cancleBtnClick={() => setDeleteModalOpen(false)}
          loading={loading}
        />
      )}
      {isAssignRoomModalOpen && (
        <AssignRoomModal
          headerTitle="Assign Room"
          idName={"Blasterlist"}
          assignData={assignData}
          handleRefresh={handleRefresh}
          cancleBtnClick={() => {
            setIsAssignRoomModalOpen(false);
            setAssignData({});
          }}
        />
      )}

      <ChipsDataTable
        apiURL={`${url.BASE_URL}${url.GET_BLASTER_LIST}`}
        title="Blaster List"
        customStyles={customStyles}
        selectedRoomID={selectedRooms}
        columns={columns}
        isReload={isReload}
        expandableRows={true}
        ExpandedComponent={ExpandedComponent}
        ExpandCollapseIcon={ExpandCollapseIcon}
        idName={"Blasterlist"}
        loading={loading}
        setLoading={setLoading}
        selectedRows={selectedRows}
        setSelectedRows={setSelectedRows}
        userId={userId}
        handleDeleteAll={handleDeleteAll}
      />
    </div>
  );
};

export default BlasterList;

export const ExpandedComponent = ({ data }: { data: any }) => {
  const switchColumns: any[] = [
    {
      name: "Remote Name",
      selector: (row: any) => row.displayName,
      sortable: true,
    },
    {
      name: "Room Name",
      selector: (row: any) => row.roomId?.name || "-",
      sortable: true,
    },
    {
      name: "Image",
      selector: (row: any) => row.image || "-",
      sortable: true,
    },
    {
      name: "Type",
      selector: (row: any) => row.type || "-",
      sortable: true,
    },
    {
      name: "	Brand Name",
      selector: (row: any) => row.brandName || "-",
      sortable: true,
    },

    {
      name: "Brand Model",
      selector: (row: any) => row.brandModal || "-",
      sortable: true,
    },
  ];

  return (
    <div className="p-2">
      <DataTable
        columns={switchColumns}
        data={data.remotes || []}
        dense
        highlightOnHover
        noDataComponent="No remotes available"
        customStyles={customStyles}
        expandableRows={true}
        expandableRowsComponent={ExpandedComponentSecond}
        expandableIcon={{
          collapsed: <ExpandCollapseIcon expanded={false} />,
          expanded: <ExpandCollapseIcon expanded={true} />,
        }}
      />
    </div>
  );
};

export const ExpandedComponentSecond = ({ data }: { data: any }) => {
  const switchColumns: any[] = [
    {
      name: "Key ID",
      selector: (row: any) => row.switchKeyId || "-",
      sortable: true,
    },
    {
      name: "Key Name",
      selector: (row: any) => row.switchKeyName || "-",
      sortable: true,
    },
  ];

  return (
    <div className="p-2">
      <DataTable
        columns={switchColumns}
        data={data.switches || []}
        dense
        highlightOnHover
        noDataComponent="No switches available"
        customStyles={customStyles}
      />
    </div>
  );
};
export const customStyles: any = {
  tableWrapper: {
    style: {
      minWidth: "1100px",
    },
  },
  subHeader: {
    style: {
      padding: "0px",
      margin: "0px",
    },
  },
  headRow: {
    style: {
      backgroundColor: "#EFF2F7",
      fontWeight: "bold",
      fontSize: "14px",
      borderBottom: "none",
    },
  },
  rows: {
    style: {
      fontSize: "14px",
      color: "#343a40",
      borderBottom: "none",
    },
  },
  cells: {
    style: {
      fontSize: "14px",
      color: "#343a40",
      borderBottom: "none",
    },
  },
};

export const ExpandCollapseIcon = ({ expanded }: { expanded: boolean }) => {
  return (
    <div
      className="d-flex justify-content-center align-items-center  "
      style={{ cursor: "pointer", width: "32px", height: "32px" }}
    >
      <i
        className={`bx ${
          expanded ? "bx-caret-down" : "bx-caret-right"
        } text-dark fs-5`}
      ></i>
    </div>
  );
};
